import classes from "./CompanyMode.module.scss";
import LoadingDots from "../UI/LoadingDots";
import { useState, useEffect, useContext, forwardRef, useImperativeHandle } from "react";
import { DDD, E2Data} from "../../lib/ddd/ddd";
import { useQuery } from '@tanstack/react-query'
import {  Col, Container, Row } from "react-bootstrap";
import Button from "../UI/Button";
import { NavLink } from "react-router-dom";
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import { OrgIdContext } from "../../store/orgId_context";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Checkbox } from "@mui/material";
import { UserUIStateContext } from "../../store/userUIStateContext";
import { useTranslation } from 'react-i18next';

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const e2Data_EU_AOrg = new E2Data("EU_AOrg");
const ddd = new DDD(apiRequestAddress);

const SLA =  forwardRef((props, ref)=>{
    const [error, setError] = useState();
    const {clientWizardStep} = useContext(UserUIStateContext);
    const {aboutOrgId } = useContext(OrgIdContext);
    const [sla, setSLA] = useState(clientWizardStep > 4);
    const [terms, setTerms] = useState(clientWizardStep > 4);
    const { t } = useTranslation();
    
    const validate = () =>{
        if(!sla || !terms){
            setError(t("To continue you much agree with the SLA agreement and Terms & Conditions"));
            setTimeout(() => {
                setError(false);
            }, 5000);
            return false;
        }else{
            enableAgreements();
            return true;
        }
    }
    
    const enableAgreements = () => {
        e2Data_EU_AOrg.filter = `Id="${aboutOrgId}"`;
        e2Data_EU_AOrg.values = {PublicSLAAgreed : true, PublicTermsAndConditionsAgreed : true}
        e2Data_EU_AOrg.Modify();
        ddd.InvalidateSessionExtensions();
    }

    useImperativeHandle(ref, () =>{
        return{
            validate(){
                return validate();
            }
        }
    },[sla, terms, validate]);

    
    return (
        <>
        <Container className={`${classes["container"]} d-flex flex-column`} style={{marginBottom:"2rem",marginTop: "1rem"}}>
            <Row>
                <Col><Checkbox id="slach" checked={sla} size="small" onChange={(e) => setSLA(e.target.checked)}/> <label for="slach">{t("I agree with SLA")}</label></Col>
                <Col><Checkbox id="tcch" checked={terms} size="small" onChange={(e) => setTerms(e.target.checked)}/><label for="tcch">{t("I agree with Terms & conditions")}</label></Col>
            </Row>
            {error && 
            <Row className={classes["errorAlert"]}>
                <Col className="col-1"><ErrorOutlineIcon style={{width:"2rem", height:"2rem", color:"red"}} /></Col>
                <Col>{error}</Col>
            </Row>
            }
        </Container>
        <Container className={`${classes["container"]} d-flex flex-column`}>
            {error && false && 
                <Row className={classes["errorAlert"]}>
                    <Col className="col-1"><ErrorOutlineIcon style={{width:"2rem", height:"2rem", color:"red"}} /></Col>
                    <Col>{error}</Col>
                </Row>
                }
            <Row>
                <div>{t("Service and licence agreement")}</div>
            </Row>
            <Row style={{height:"80vh"}}>
            <iframe
                key={"SLA"}
                src={process.env.REACT_APP_ORIGIN ?  process.env.REACT_APP_ORIGIN+`/File/e785e9da-a600-4fb3-8520-8943d22e44aa?inline=true` : `/File/e785e9da-a600-4fb3-8520-8943d22e44aa?inline=true`}
                title={`iframe-invoiceIframe`}
                width="100%"
                height="100%"
            ></iframe>
            </Row>
        </Container>
        <Container className={`${classes["container"]} d-flex flex-column`} style={{marginTop:"2rem"}}>
            <Row>
                <div>{t("Terms and conditions")}</div>
            </Row>
            <Row style={{height:"80vh"}}>
            <iframe
                key={"SLA"}
                src={process.env.REACT_APP_ORIGIN ?  process.env.REACT_APP_ORIGIN+`/File/fa09445a-417a-43f7-a23b-c057e5082fe3?inline=true` : `/File/fa09445a-417a-43f7-a23b-c057e5082fe3?inline=true`}
                title={`iframe-invoiceIframe`}
                width="100%"
                height="100%"
            ></iframe>
            </Row>
            
        </Container>
        <Container className={`${classes["container"]} d-flex flex-column`} style={{marginTop:"2rem"}}>
            <Row>
                <Col><Checkbox id="slac2" checked={sla} size="small" onChange={(e) => setSLA(e.target.checked)}/> <label for="slac2">{t("I agree with SLA")}</label></Col>
                <Col><Checkbox id="tcch2" checked={terms} size="small" onChange={(e) => setTerms(e.target.checked)}/><label for="tcch2">{t("I agree with Terms & conditions")}</label></Col>
            </Row>
            {error && 
            <Row className={classes["errorAlert"]}>
                <Col className="col-1"><ErrorOutlineIcon style={{width:"2rem", height:"2rem", color:"red"}} /></Col>
                <Col>{error}</Col>
            </Row>
            }
        </Container>
        </>
    )
});

export default SLA;